import React from 'react'
import { Link } from 'react-router-dom'
import PT from 'prop-types'

const AuthorInfo = props => (
  <Link to={props.linkDetail} className="author">
    <span className="type">{props.type}</span>
    <span className="name">od: {props.name}</span>
    <span className="date">{props.date}</span>
  </Link>
)

AuthorInfo.propTypes = {
  date: PT.string.isRequired,
  name: PT.string.isRequired,
  linkDetail: PT.string.isRequired,
  type: PT.string.isRequired,
}

export default AuthorInfo



// WEBPACK FOOTER //
// ./src/components/Post/AuthorInfo.js